export function getAuditConfigs() {
  return {
    url: `${process.env.REACT_APP_ORIGIN}/audit/config`,
    method: 'GET',
  }
}
